module.exports = __webpack_public_path__ + "static/media/thealternativeboard.7ce54de8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/thealternativeboard.webp
// module id = 521
// module chunks = 0